import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { base44 } from '@/api/base44Client';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { Construction } from 'lucide-react';

export default function MaintenanceToggle() {
  const queryClient = useQueryClient();

  const { data: settings = [] } = useQuery({
    queryKey: ['site-settings'],
    queryFn: () => base44.entities.SiteSettings.list()
  });

  const maintenanceSetting = settings.find(s => s.key === 'maintenance_mode');
  const isMaintenanceMode = maintenanceSetting?.value || false;

  const toggleMaintenance = useMutation({
    mutationFn: async (enabled) => {
      if (maintenanceSetting) {
        await base44.entities.SiteSettings.update(maintenanceSetting.id, { value: enabled });
      } else {
        await base44.entities.SiteSettings.create({ key: 'maintenance_mode', value: enabled });
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['site-settings'] });
      toast.success(isMaintenanceMode ? 'Modalità manutenzione disattivata' : 'Modalità manutenzione attivata');
    }
  });

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Construction className="w-5 h-5" />
          Modalità Manutenzione
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex items-center justify-between">
          <div className="space-y-1">
            <Label htmlFor="maintenance-mode" className="text-base">
              Work in Progress
            </Label>
            <p className="text-sm text-[#7a7a7a]">
              Quando attiva, solo gli admin possono vedere il sito. Gli altri vedono "Sito in costruzione".
            </p>
          </div>
          <Switch
            id="maintenance-mode"
            checked={isMaintenanceMode}
            onCheckedChange={(checked) => toggleMaintenance.mutate(checked)}
          />
        </div>
      </CardContent>
    </Card>
  );
}